import React from "react";

import { ReactComponent as OrganizetionDesktopIcon } from "../../../assets/svgs/organization-desktop.svg";
import { ReactComponent as OrganizetionMobileIcon } from "../../../assets/svgs/organization-mobile.svg";

import useWindowSize from "hooks/useWindowSize";

import * as S from "./SectionOrganize.Style";

const SectionOrganize = () => {
  const { width } = useWindowSize();
  const isMobile = width && width <= 992;

  return (
    <S.SectionOrganizeContainer className="container">
      <S.SectionOrganizeHeader>
        <S.SectionOrganizeTitle>Como nos organizamos</S.SectionOrganizeTitle>

        <S.SectionOrganizeDescription>
          Entenda como a estrutura societária da CSH está organizada. Um modelo
          que fortalece a presença no mercado e promove sinergia nas operações.
        </S.SectionOrganizeDescription>
      </S.SectionOrganizeHeader>

      <S.SectionOrganizeImage>
        {isMobile ? <OrganizetionMobileIcon /> : <OrganizetionDesktopIcon />}
      </S.SectionOrganizeImage>
    </S.SectionOrganizeContainer>
  );
};

export default SectionOrganize;
